import API from "../../../../../services/api";

export const CARROCERIAS_PESADAS_API = {
  get: async () => {
    return API.get("/carrocerias-pesadas").then((res) => res.data);
  },
  new: async (data) => {
    return API.post("/carrocerias-pesadas", data).then((res) => res.data);
  },
  update: async(id, data) => {
    return API.put(`/carrocerias-pesadas/${id}`, data).then((res) => res.data );
  }
}
